import React from 'react';
import './Productcard.css'; // Optional for custom styles
import { Link } from 'react-router-dom';

const Productcard = (props) => {

    const truncateTitle = (title, maxLength = 35) => {
        if (!title) return '';
        return title.length > maxLength ? title.substring(0, maxLength).trim() + '...' : title;
    };

    const hasRealDiscount = props.preprice && props.preprice > props.price;
    const discountPct = hasRealDiscount
        ? Math.round((1 - props.price / props.preprice) * 100)
        : 40;

    const originalPrice = hasRealDiscount
        ? props.preprice
        : Math.round(props.price * 1.4);

  const delPro = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this product?");
    if (!confirmDelete) return; // Stop if user clicks Cancel

    fetch(`https://pentadeco.in/api/delpro/${props.id}`)
      .then(res => res.json())
      .then(data => {
        if (!data.success) {
          alert("Failed to delete product");
          console.log(data);
        } else {
          alert("Product deleted successfully");
          // Optional: refresh or remove product from UI here
        }
      })
      .catch(err => console.log('Error occurred while deleting the product', err));
  };
  
  return (
    <div className="pro-card position-relative h-100">

        {/* Discount badge */}
        <div className="pro-card-badge">{discountPct}% OFF</div>

        {/* Image */}
        <Link to={`/${props.id}/${props.name.toLowerCase().replaceAll(' ', '-')}`} className="nav-link">
            <div className="pro-card-img-wrap">
                <img src={props.coverimg} className="pro-card-img" alt={props.name} />
            </div>
        </Link>

        {/* Body */}
        <div className="pro-card-body">
            <Link to={`/${props.id}/${props.name.toLowerCase().replaceAll(' ', '-')}`} className="nav-link d-flex flex-column h-100">
                <p className="pro-card-cat">{props?.category}</p>
                <p className="pro-card-name">{truncateTitle(props.name)}</p>
                <div className="pro-card-footer mt-auto">
                    <div>
                        <p className="pro-card-orig">₹{originalPrice}</p>
                        <p className="pro-card-price"><span className="pro-card-sup">₹</span>{props.price}</p>
                    </div>
                    <span className="pro-card-btn">View Details</span>
                </div>
            </Link>

            {props.admin && (
                <div className="d-flex justify-content-between mt-3 gap-2">
                    <button className="btn btn-danger fs-eesm text-nowrap rounded-pill px-3 w-50" onClick={delPro}>Delete</button>
                    <Link to={`/dashboard/editproduct/${props.id}`} className="btn btn-primary fs-eesm text-nowrap rounded-pill px-3 w-50 text-center">Edit</Link>
                </div>
            )}
        </div>
    </div>
  );
};

export default Productcard;
